import { render } from "./KnowledgeChatFab.vue?vue&type=template&id=4bef07e8&scoped=true"
import script from "./KnowledgeChatFab.vue?vue&type=script&lang=js"
export * from "./KnowledgeChatFab.vue?vue&type=script&lang=js"

import "./KnowledgeChatFab.vue?vue&type=style&index=0&id=4bef07e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bef07e8"]])

export default __exports__